var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center loading-spinner",staticStyle:{"gap":"0.5rem"}},[_c('span',[_vm._v(_vm._s(_vm.loadingText || "Loading"))]),_vm._v(" "),_c('i',{staticClass:"icon icon-circle-notch"})])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./Features/Shared/VueComponents/loading-spinner.vue?vue&type=template&id=cfb5e164&